import React from 'react';
import { useTheme } from '../../context/ThemeContext';
import { Sun, Moon } from '@phosphor-icons/react';

export function ThemeToggle() {
  const { theme, toggleTheme } = useTheme();
  const isDark = theme === 'dark';

  return (
    <button
      onClick={toggleTheme}
      title={`Switch to ${isDark ? 'light' : 'dark'} mode`}
      data-testid="theme-toggle"
      className="relative inline-flex items-center h-9 w-[68px] rounded-full overflow-hidden transition-all duration-300"
      style={{
        background: isDark
          ? 'linear-gradient(135deg, #141B25, #0D131C)'
          : 'linear-gradient(135deg, #EDF1F6, #FFFFFF)',
        border: '1px solid var(--border-default)',
        boxShadow: 'inset 0 1px 2px rgba(0,0,0,0.15)',
      }}
      aria-label="Toggle theme"
    >
      {/* Track icons */}
      <span
        className="pointer-events-none absolute left-2 top-1/2 -translate-y-1/2 transition-opacity duration-200"
        style={{ opacity: isDark ? 0.4 : 0 }}
      >
        <Moon className="h-3.5 w-3.5" weight="fill" style={{ color: 'var(--accent-primary)' }} />
      </span>
      <span
        className="pointer-events-none absolute right-2 top-1/2 -translate-y-1/2 transition-opacity duration-200"
        style={{ opacity: isDark ? 0 : 0.5 }}
      >
        <Sun className="h-3.5 w-3.5" weight="fill" style={{ color: 'var(--accent-primary)' }} />
      </span>

      {/* Thumb */}
      <span
        className="pointer-events-none absolute top-1 flex items-center justify-center h-7 w-7 rounded-full transition-all duration-[360ms]"
        style={{
          left: isDark ? '4px' : '36px',
          background: 'var(--gradient-accent)',
          boxShadow: '0 2px 8px rgba(0,0,0,0.35), 0 0 0 1px rgba(0,0,0,0.1)',
        }}
      >
        {isDark ? (
          <Moon className="h-4 w-4" weight="fill" style={{ color: '#0A0E14' }} />
        ) : (
          <Sun className="h-4 w-4" weight="fill" style={{ color: '#FFFFFF' }} />
        )}
      </span>
    </button>
  );
}

export default ThemeToggle;
